export default function formatElapsedTime(value) {
        const elapsedMs = Math.max(0, Math.floor(value));
        const totalSeconds = Math.floor(elapsedMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const centiseconds = Math.floor((elapsedMs % 1000) / 10);

        const mm = String(minutes).padStart(2, "0");
        const ss = String(seconds).padStart(2, "0");
        const cc = String(centiseconds).padStart(2, "0");
        return `${mm}:${ss}.${cc}`;
}
